<div class="flex flex-col gap-2">
  <form
    [formGroup]="destinationForm"
    class="flex flex-col gap-2"
  >
    <div class="flex gap-2 dark">
      <div
        [ngClass]="{ 'w-full': isUiDestinationRequired(), 'w-1/2': !isUiDestinationRequired() }"
        class="flex flex-col"
      >
        <flx-label class="font-semibold text-white">Choose Node</flx-label>
        <p-select
          [options]="
            isBusinessRuleDestinationRequired() ? destinationTasks() : uiDestinationTasks()
          "
          class="flx-prime-select small dark"
          optionLabel="label"
          optionValue="id"
          formControlName="nodeId"
          placeholder="Choose node"
          appendTo="body"
          panelStyleClass="flx-prime-select small dark dark-panel"
        >
          <ng-template pTemplate="empty">
            <div class="text-xs text-neutral-400">No results found</div>
          </ng-template>

          <ng-template
            let-option
            pTemplate="item"
          >
            <div class="role-dropdown-item">
              <span>{{ option.label }}</span>
            </div>
          </ng-template>

          <ng-template
            let-option
            pTemplate="selectedItem"
          >
            <div class="role-dropdown-item flex gap-2 items-center">
              @if (option.type === ActivityNode.USER_TASK) {
                <i class="ph ph-user text-neutral-500"></i>
              } @else if (option.type === ActivityNode.TASK) {
                <i class="ph ph-task text-neutral-500"></i>
              } @else if (option.type === ActivityNode.MESSAGE_EVENT_SEND) {
                <i class="ph ph-message-circle text-neutral-500"></i>
              }
              <span>{{ option.label }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>

      @if (isBusinessRuleDestinationRequired()) {
        <div class="flex flex-col w-1/2">
          <flx-label class="font-semibold text-white">Choose Action</flx-label>
          <p-select
            [options]="actions()"
            class="h-7 flx-prime-select small dark"
            optionLabel="name"
            optionValue="id"
            formControlName="actionId"
            placeholder="Choose action"
            appendTo="body"
            panelStyleClass="flx-prime-select small dark dark-panel"
          >
            <ng-template pTemplate="empty">
              <div class="text-xs text-neutral-400">No results found</div>
            </ng-template>

            <ng-template
              let-option
              pTemplate="item"
            >
              <div class="role-dropdown-item">
                <span>{{ option.name }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
      }

      @if (isExpressionDestinationRequired()) {
        <div class="flex flex-col w-1/2">
          <flx-label class="font-semibold text-neutral-500">Selected Component</flx-label>
          <p-select
            [options]="templateConfigs()"
            class="h-7 flx-prime-select small dark"
            optionLabel="label"
            optionValue="id"
            formControlName="templateConfigId"
            placeholder="None"
            appendTo="body"
            panelStyleClass="flx-prime-select small dark dark-panel"
          />
        </div>
      }
    </div>

    @if (isExpressionDestinationRequired()) {
      <div class="flex flex-col dark">
        <flx-label class="font-semibold text-neutral-500">Expression Type</flx-label>
        <p-select
          [options]="expressionTypes"
          class="h-7 flx-prime-select small dark"
          optionLabel="label"
          optionValue="id"
          formControlName="expressionType"
          placeholder="Expression"
          appendTo="body"
          panelStyleClass="flx-prime-select small dark dark-panel"
        />
      </div>
    }

    @if (isBusinessRuleDestinationRequired()) {
      <div class="flex gap-2">
        <div class="flex flex-col w-full dark">
          <flx-label class="font-semibold text-white">Choose Business Rule</flx-label>
          <p-select
            [options]="businessRules()"
            class="h-7 flx-prime-select small dark w-full"
            optionLabel="label"
            optionValue="id"
            formControlName="businessRuleIndex"
            placeholder="Choose business rule"
            appendTo="body"
            panelStyleClass="flx-prime-select small dark dark-panel"
            sele
          >
            <ng-template pTemplate="empty">
              <div class="text-xs text-neutral-400">No results found</div>
            </ng-template>

            <ng-template
              let-option
              pTemplate="item"
            >
              <div class="role-dropdown-item">
                <span>{{ option.label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
    }
  </form>

  @if (showExpressionError() && destinationForm.get('templateConfigId')?.value) {
    <div
      class="flex items-center text-xs/[18px] rounded-lg px-2 py-1 text-xs bg-red-400/[.3] gap-2 w-full"
    >
      <i class="ph ph-warning-circle text-red-400 text-xs"></i>
      <span class="text-white"
        >Selected component does not support "{{
          destinationForm.get('expressionType')?.value | lowercase
        }}" expressions.</span
      >
    </div>
  }

  @if (selectedTemplateConfigIds().length > 1) {
    <div
      class="flex items-center h-7 text-xs/[18px] rounded-lg px-2 py-1 text-xs bg-red-400/[.3] gap-2 w-full"
    >
      <i class="ph ph-warning-circle text-red-400 text-xs"></i>
      <span class="text-white">Cannot apply on multiple components</span>
    </div>
  }

  <div class="flex gap-2 w-full">
    @if (destinationForm.valid) {
      <button
        [disabled]="showExpressionError()"
        [class.opacity-50]="showExpressionError()"
        (click)="onImplementClick()"
        class="flex items-center h-7 text-xs/[18px] rounded-lg px-2 py-1 text-xs bg-white/[.1] gap-2"
        flxButton
      >
        <i class="ph ph-sparkle text-yellow-500 text-xs"></i>
        <span class="text-white">{{ implementButtonLabel() }}</span>
      </button>
    }

    <button
      (click)="onCancelClick()"
      class="flex items-center h-7 text-xs/[18px] rounded-lg px-2 py-1 text-xs bg-white/[.1] gap-2"
      flxButton
    >
      Cancel
    </button>
  </div>
</div>
